import { render, staticRenderFns } from "./permissionSetting.vue?vue&type=template&id=19f2716c&scoped=true&"
import script from "./permissionSetting.vue?vue&type=script&lang=js&"
export * from "./permissionSetting.vue?vue&type=script&lang=js&"
import style0 from "./permissionSetting.vue?vue&type=style&index=0&id=19f2716c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f2716c",
  null
  
)

export default component.exports